import * as PIXI from "pixi.js";
import { Coord } from "../../types/Interface";
import { ArrowCap, LineEqualSymbol } from "../../types/Enum";
import { genDashedCoords, getArrowCapsCoords, getArrowSymbolCoords, getEqualSymbolCoords } from "./helpers/DrawingHelpers";


export default class LineFactory {
  private width!: number;
  private lineColor!: number
  constructor(width: number, lineColor: number) {
    this.width = width;
    this.lineColor = lineColor;
  }

  setLineColor = (color: number) => this.lineColor = color;

  drawLines(graphic: PIXI.Graphics, coordStart: Coord, coordEnd: Coord, isDashed: boolean) {
    const coords = !isDashed
      ? [coordStart, coordEnd]
      : genDashedCoords(coordStart, coordEnd);
    if(!graphic){
      return
    }
    graphic.clear();
    
    coords.forEach((coord, cI) => {
      if (cI % 2 === 1) return;

      const nextI = cI != coords.length - 1 ? cI + 1 : cI;

      graphic
        .moveTo(coord.x, coord.y)
        .lineTo(coords[nextI].x, coords[nextI].y)
        .stroke({ color: this.lineColor, width: this.width, cap: "round" });
    })
  }
  drawEqualSymbol(type: LineEqualSymbol, graphic: PIXI.Graphics, coordStart: Coord, coordEnd: Coord) {
    switch (type) {
      case LineEqualSymbol.Dash:
        this.drawDashSymbol(graphic, coordStart, coordEnd);
        break;
      case LineEqualSymbol.Arrow:
        this.drawArrowSymbol(graphic, coordStart, coordEnd);
        break;
      default:
        break;
    }
  }
  drawDashSymbol(graphic: PIXI.Graphics, coordStart: Coord, coordEnd: Coord) {
    const coords = getEqualSymbolCoords(coordStart, coordEnd);
    graphic
      .moveTo(coords[0].x, coords[0].y)
      .lineTo(coords[1].x, coords[1].y)
      .stroke({ color: this.lineColor, width: this.width, cap: "round" })
  }
  drawArrowSymbol(graphic: PIXI.Graphics, coordStart: Coord, coordEnd: Coord) {
    const coords = getArrowSymbolCoords(coordStart, coordEnd);
    graphic
      .moveTo(coords[0].x, coords[0].y)
      .lineTo(coords[1].x, coords[1].y)
      .lineTo(coords[2].x, coords[2].y)
      .stroke({ width: this.width, color: this.lineColor, cap: "round" });
  }

  drawArrowCaps(graphic: PIXI.Graphics, coordStart: Coord, coordEnd: Coord, arrowCap: ArrowCap) {
    if (arrowCap === ArrowCap.None) return;
    const coordsArr: Coord[][] = getArrowCapsCoords(coordStart, coordEnd, arrowCap);
    coordsArr.forEach(coords => {
      graphic
        .moveTo(coords[0].x, coords[0].y)
        .lineTo(coords[1].x, coords[1].y)
        .lineTo(coords[2].x, coords[2].y)
        .stroke({ width: 1, color: this.lineColor, cap: "round" })
        .fill(this.lineColor);
    })
  }
}